import React from 'react'
import PropTypes from 'prop-types'
import { LeaguesTypes } from '../../constants'

const typeIconClassName = {
  [ LeaguesTypes.LEAGUE ]: 'cls-lb-icon-league',
  [ LeaguesTypes.EVENT ]: 'cls-lb-icon-event',
  [ LeaguesTypes.TRIP ]: 'cls-lb-icon-trip',
  [ LeaguesTypes.NON_GOLF_EVENT ]: 'cls-lb-icon-non-golf-event',
  [ LeaguesTypes.DRIVE_CHIP_PUTT ]: 'cls-lb-icon-dcp',
}

const typeDisplayedChars = {
  [ LeaguesTypes.LEAGUE ]: 'L',
  [ LeaguesTypes.EVENT ]: 'E',
  [ LeaguesTypes.TRIP ]: 'T',
  [ LeaguesTypes.NON_GOLF_EVENT ]: 'NG',
  [ LeaguesTypes.DRIVE_CHIP_PUTT ]: 'DCP',
}

const typeDisplayedText = {
  [ LeaguesTypes.LEAGUE ]: window.I18n.t('clone_leagues_sessions.general.league'),
  [ LeaguesTypes.EVENT ]: window.I18n.t('clone_leagues_sessions.general.event'),
  [ LeaguesTypes.TRIP ]: window.I18n.t('clone_leagues_sessions.general.trip'),
  [ LeaguesTypes.NON_GOLF_EVENT ]: window.I18n.t('clone_leagues_sessions.general.non_golf_event'),
  [ LeaguesTypes.DRIVE_CHIP_PUTT ]: window.I18n.t('clone_leagues_sessions.general.dcp'),
}

const LeaguesTypeIcon = ({ leagueType, compact = false }) => {
  return (
    <span className={typeIconClassName[leagueType]}>
      {compact ? typeDisplayedChars[leagueType] : typeDisplayedText[leagueType]}
    </span>
  )
}

LeaguesTypeIcon.propTypes = {
  leagueType: PropTypes.oneOf(Object.values(LeaguesTypes)).isRequired,
  compact: PropTypes.bool,
}

export default LeaguesTypeIcon
